// Contract 29 §8 — `CompleteOnboardingFlow`. Ports `OnboardingModal.vue:155-172`.
//
// Dropped with the port: the `setTimeout(…, 100)` before the push — a race workaround the store
// reset removes.

import type { RouteLocationRaw } from 'vue-router'

/** A new account enters the one-week Get Started journey (contract 29 §3.9); the route guard
 *  sends anyone ineligible on to Summary. */
export const ONBOARDING_FINISH_ROUTE: RouteLocationRaw = { name: 'GetStarted' }

export interface CompleteOnboardingDependencies {
  /** GTM funnel close — `onboarding_completed` (§9 `useOnboardingAnalytics`). */
  trackCompleted: () => void
  resetOnboarding: () => void
  /** 07's ONE context-reload entry (ledger B6) — `loadSelectedAccountContext(true)`. */
  reloadContext: () => Promise<unknown>
  navigate: (to: RouteLocationRaw) => Promise<unknown>
  report?: (scope: string, error: unknown) => void
}

export class CompleteOnboardingFlow {
  constructor(private readonly deps: CompleteOnboardingDependencies) {}

  async execute(): Promise<void> {
    this.deps.trackCompleted()
    this.deps.resetOnboarding()
    try {
      // The account context must carry the new workspace before the app surface renders it. A
      // reload failure still lands the user somewhere real rather than trapping them in a wizard
      // whose state has already been reset.
      await this.deps.reloadContext()
    } catch (error: unknown) {
      this.deps.report?.('onboarding.reload_context', error)
    }
    await this.deps.navigate(ONBOARDING_FINISH_ROUTE)
  }
}
